export default __webpack_public_path__ + "static/media/hop-logo-black.33558851.png";